import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';

export const BILANS_ANNUELS_ROUTES: Routes = [
  {
    path: 'bilans-annuels/list',
    loadComponent: () =>
      import('../features/bilans-annuels/list/list.component').then(
        (m) => m.BilansAnnuelsListComponent
      ),
    canActivate: [AuthGuard, GestionnaireGuard]
  }
];
